export default __webpack_public_path__ + "static/media/book2.aa483116.jpg";